module.exports = __webpack_public_path__ + "packs/media/images/palestraWide-efdd12225accc66e9e7ed521deb0c2e8.jpg";